export class PlayersCollection {
    constructor() {
        this.playersMap = new Map();
        this.subs = new Set();
    }
    get empty() {
        return this.playersMap.size === 0;
    }
    get size() {
        return this.playersMap.size;
    }
    *[Symbol.iterator]() {
        for (const player of this.playersMap.values()) {
            yield player;
        }
    }
    clear() {
        if (this.playersMap.size === 0) {
            return;
        }
        this.playersMap.clear();
        this.beat();
    }
    has(playerId) {
        return this.playersMap.has(playerId);
    }
    add(...players) {
        let beat = false;
        players.forEach(player => {
            if (this.playersMap.has(player.id)) {
                return;
            }
            this.playersMap.set(player.id, player);
            beat = true;
        });
        if (beat) {
            this.beat();
        }
    }
    get(playerId) {
        return this.playersMap.get(playerId);
    }
    delete(playerId) {
        if (!this.playersMap.has(playerId)) {
            return;
        }
        this.playersMap.delete(playerId);
        this.beat();
    }
    subscribe(sub) {
        if (!this.subs.has(sub)) {
            this.subs.add(sub);
            sub(this);
        }
        return () => this.subs.delete(sub);
    }
    beat() {
        this.subs.forEach(sub => sub(this));
    }
}
